import {
  CAT_IN_A_FLAT_DOMAINS,
  DOG_BUDDY_DOMAINS,
  MADPAWS_DOMAINS,
} from '@rover/constants/src/platform/domains.constants';
import { RoverBrand } from '@rover/types/src/RoverBrand';
import { matchesAnyDomain } from '@rover/utilities/getRoverBrand/domain-utils';
import { getDevBrand } from '@rover/utilities/getRoverBrand/getDevBrand';

const DOMAIN_PROPERTY_MAP = [
  {
    domains: CAT_IN_A_FLAT_DOMAINS,
    brand: RoverBrand.CatInAFlat,
  },
  {
    domains: DOG_BUDDY_DOMAINS,
    brand: RoverBrand.DogBuddy,
  },
  {
    domains: MADPAWS_DOMAINS,
    brand: RoverBrand.MadPaws,
  },
];

/** Accepts a bare hostname or `hostname:port`; a dev brand port wins over the hostname. */
const getRoverBrandFromHostname = (host: string): RoverBrand => {
  const devBrand = getDevBrand(host);
  if (devBrand) {
    return devBrand;
  }

  const [hostname] = host.split(':');
  return (
    DOMAIN_PROPERTY_MAP.find(({ domains }) => matchesAnyDomain(hostname, domains))?.brand ??
    RoverBrand.Rover // Default to Rover brand
  );
};

export default getRoverBrandFromHostname;
